import { getSavedItems } from "../../../../../../services/savedItems";

const getSavedItemsRequest = ({ params }) => getSavedItems(params);

export default getSavedItemsRequest;
